"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setIsServer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var actionTypes_1 = require("./actionTypes");
exports.setIsServer = (0, typesafe_actions_1.createAction)(actionTypes_1.ConfigActionType.SET_IS_SERVER)();
